import { MIN_PASSWORD_LENGTH } from "@repo/auth/client"
import { Button } from "@repo/ui/components/button"
import { ResetPasswordForm } from "@repo/ui/components/auth-forms"
import { Link, useSearchParams } from "react-router"

import { AuthLayout } from "@/components/auth-layout"
import { authClient } from "@/lib/auth-client"

export function ResetPasswordPage() {
  const [params] = useSearchParams()
  const token = params.get("token")
  const signInLink = (
    <Button render={<Link to="/login" />} nativeButton={false} size="lg">
      Sign in
    </Button>
  )

  return (
    <AuthLayout>
      {token ? (
        <ResetPasswordForm
          minLength={MIN_PASSWORD_LENGTH}
          signInLink={signInLink}
          onSubmit={async (newPassword) => {
            const { error } = await authClient.resetPassword({
              newPassword,
              token,
            })

            return error ? (error.message ?? "Something went wrong") : null
          }}
        />
      ) : (
        <div className="flex flex-col items-center gap-4 text-center">
          <h1 className="font-sans text-2xl font-semibold tracking-tight">
            Link expired
          </h1>
          <p className="text-sm text-muted-foreground">
            This reset link is invalid or has already been used.
          </p>
          <Button
            render={<Link to="/forgot-password" />}
            nativeButton={false}
            size="lg"
          >
            Request a new link
          </Button>
        </div>
      )}
    </AuthLayout>
  )
}
